/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Button from 'components/common/Button';
import { Roles } from '../../../shared/enums/Roles';
import { IsInRole } from '../../../shared/authorization/IsInRole';
import EmptyTableBase from './EmptyTableBase';
import { DraftManagementContext } from '../../../pages/draftManagement/useDraftManagement';

const useStyles = makeStyles(theme => ({
  text: {
    margin: 0,
    '&:last-of-type': {
      marginBottom: '2rem',
    },
  },
  title: {
    fontWeight: '600',
    fontSize: '2rem',
    color: theme.palette.secondary.contrastText,
    marginBottom: '0.5rem',
  },
}));

export default function EmptyTable({ className, icon, warningMessage, suggestion, error }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { createButton } = useContext(DraftManagementContext);
  return (
    <EmptyTableBase className={className} icon={icon}>
      {error && <p className={classes.title}>{warningMessage}</p>}
      {!error && <p className={classes.text}>{warningMessage}</p>}
      <IsInRole roles={[Roles.SUBMISSION_DRAFTER]}>
        <p className={classes.text}>{suggestion || t('submission.start.creating')}</p>
      </IsInRole>
      {error ? (
        <Button
          className={classes.importButton}
          color="primary"
          onClick={() => {
            window.location.reload();
          }}
        >
          {t('button.refresh.label')}
        </Button>
      ) : (
        createButton
      )}
    </EmptyTableBase>
  );
}
